'use client';
import React from 'react';
import Link from 'next/link';
import GradientSection from '../ui/GradientSection';
import PrimaryCTA from '../ui/PrimaryCTA';
import SecondaryCTA from '../ui/SecondaryCTA';

const CTASection = ({
  title,
  heading,
  description = "Whether we've worked together before or this could be our first joint venture, we're excited to get the conversation going.",

  primaryLabel,
  buttonText,
  primaryHref = "/quote",
  href,

  secondaryLabel,
  secondaryHref,

  id = "cta",
  children
}) => {
  const finalHeading = heading || title || "Let's Print Something Brilliant!";
  const finalPrimaryLabel = primaryLabel || buttonText || "Schedule Consultation";
  const finalPrimaryHref = primaryHref || href || "/quote";

  return (
    <section className="w-full bg-white section-shell" id={id}>
      <div className="container-fluid max-w-[1248px]">
        <div className="relative z-10 shadow-2xl rounded-[24px]">
          <GradientSection className="p-[40px] sm:p-[60px] md:p-[80px] text-center">
            <h2 className="type-section text-white mb-[16px]">
              {finalHeading}
            </h2>
            <p className="type-body text-white/90 max-w-3xl mx-auto mb-[32px]">
              {description}
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <Link href={finalPrimaryHref}>
                <PrimaryCTA>
                  {finalPrimaryLabel}
                </PrimaryCTA>
              </Link>

              {secondaryLabel && secondaryHref && (
                <Link href={secondaryHref}>
                  <SecondaryCTA>
                    {secondaryLabel}
                  </SecondaryCTA>
                </Link>
              )}
            </div>
            {children}
          </GradientSection>
        </div>
      </div>
    </section>
  );
};

export default CTASection;